module.exports = __webpack_public_path__ + "static/media/03.a1fac36e.jpg";